import { Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { CommonDataService } from '../../services/common-data.service';
import { ValidationService } from '../../services/validation.service';
import { Annotation } from '../../models/Annotation';
import { Router } from '@angular/router';
import { constObj } from '../../Constants/constants';
import { HttpcallService } from '../../services/httpcall.service';

@Component({
  selector: 'app-annotations',
  templateUrl: './annotations.component.html'
})
export class AnnotationsComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();

  constructor(
    private graphQlService: GraphqlService,
    private loginService: LoginService,
    public commonDataService: CommonDataService,
    private _validationService: ValidationService,
    private httpCallService: HttpcallService,
    private router: Router) {
  }
  textareaError: string = "";
  annotationContent: Annotation = null;
  annotationData: any;
  annotationForm = new FormGroup({
    annotationTitle: new FormControl(''),
    annotationContent: new FormControl('', [Validators.required, this._validationService.noWhitespaceValidator])
  })
  annotationDescriptionFormControl = new FormControl('');
  addAnnotationLabel: string;
  annotatingLabel: string;
  cancelButtonLabel: string;
  addButtonLabel: string;
  annotationTitleOptionalLabel: string;
  yourAnnotationLabel: string;
  editButtonLabel: string;
  editAnnotationLabel: string;
  userId: string;
  mailId: string;
  currentParagraph: string = "";
  currentParaId: string = "";
  breadcrumbPath: string = "";
  annotationBreadcrumbPath;
  pageNums;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.currentParagraph.subscribe(data1 => {
      this.currentParagraph = data1;
    });
    this.commonDataService.currentParagraphId.subscribe(data1 => {
      if (data1 != "" && data1 != null) {
        this.currentParaId = data1;
      }
    });
  
    this.commonDataService.breadcrumbPath.subscribe(path =>{
      this.breadcrumbPath = path
      this.pageNums = "";
      let crumbData = this.breadcrumbPath.split("~");
      this.annotationBreadcrumbPath = crumbData[0] + "~";
      for (let i = 1; i < crumbData.length; i++) {
        if (!crumbData[i].split(" ")[0].includes("X")) {
          this.commonDataService.currentParagraphId.subscribe(data => {
            if (data != "" && data != null) {
              this.pageNums = (data.replace("SafeValue must use [property]=binding: ", "")).replace(" (see https://g.co/ng/security#xss)", "");
            }
          })
          this.annotationBreadcrumbPath += (i != crumbData.length - 1 ? crumbData[i] + "~" : crumbData[i])
        }
      }
      if (this.pageNums != '' && this.pageNums!=null){
        this.annotationBreadcrumbPath += "~"+ this.pageNums
      }

    } );
    this.commonDataService.userId.subscribe(userData => this.userId = userData);
    this.commonDataService.mailId.subscribe(mailId => this.mailId = mailId);
    this.commonDataService.annotationContent.subscribe(data => {
      if (data != null) {
        this.annotationContent = data;
        this.remainingText = data.annotationDescription.length
        this.annotationForm.setValue({
          annotationTitle: data.annotationTitle,
          annotationContent: data.annotationDescription
        });
      }
      else {
        this.annotationContent = null;
      }
    })
    this.getAnnotationLabel();
  }
  annotationDescription: string;
  remainingText: number = 0;

  annotationDescriptionChange(value: string) {
    this.remainingText = 4000 - value.length;
  }

  closeOverlayButton() {
    this.commonDataService.annotationUpdateSource.subscribe(data => {
      if (data == "Your Annotation") {
        this.commonDataService.rightOverlayOption.next("Your Annotations");
      }
      else {
        this.closeOverlay();
      }
    })
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }

  addAnnotation() {
    if (this.annotationForm.valid) {
      this.commonDataService.showLoader.next(true);
      if (this.breadcrumbPath !== "") {
        if (this.annotationContent == null) {
          var addAnnotation: Annotation = {
            id: '-1', topicId: 'topic1', paragraphId: this.currentParagraph, annotationTitle: this.annotationForm.value.annotationTitle,
            annotationDescription: this.annotationForm.value.annotationContent,
            application: "", createdOn: "", modifiedOn: "", breadCrumb: this.annotationBreadcrumbPath, isDeleted: false, annotationsURL: this.router.url + "/" + this.currentParagraph, area: "", navigationPath: "GARS"
          }
          this.httpCall(addAnnotation, "add");
        }
        else {
          var editAnnotation: Annotation = {
            id: this.annotationContent.id, topicId: this.annotationContent.topicId, paragraphId: this.annotationContent.paragraphId,
            annotationTitle: this.annotationForm.value.annotationTitle,
            annotationDescription: this.annotationForm.value.annotationContent, 
            application: "", createdOn: this.annotationContent.createdOn, modifiedOn: "", breadCrumb: this.annotationContent.breadCrumb,
            isDeleted: false, annotationsURL: this.annotationContent.annotationsURL , area: this.annotationContent.area, navigationPath: this.annotationContent.navigationPath
          }
          this.httpCall(editAnnotation, "edit");
        }
      }
    }
    else {
      this.annotationDescriptionFormControl.setErrors({ 'required': true });
      this.textareaError = this.annotationDescriptionError;//this._validationService.getErrorMessage('required', this.yourAnnotationLabel, null);
      this.annotationDescriptionFormControl.markAsTouched();
    }
  }

  keyenter() {
    if (this.annotationForm.valid) {
      this.annotationDescriptionFormControl.setErrors(null);
      this.textareaError = "";
    }
  }

  httpCall(annotation: Annotation, operation: string) {
    this.httpCallService.addUpdateAnnotation(annotation).toPromise()
      .then(response => {
        if (response == "Annotation added successfully.") {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: (operation == "add") ? constObj.annotationAddedSuccessMessage : constObj.annotationEditedSuccessMessage
          }
          this.commonDataService.notificationObject.next(obj);
          if (operation == "add") {
            this.commonDataService.addAnnotationParagraphId.next(annotation.paragraphId);
            this.closeOverlayButton();
          }
          else {
            this.commonDataService.annotationUpdateSource.subscribe(data => {
              this.commonDataService.updateAnnotationParagraphId.next(annotation.paragraphId);
              if (data == "Your Annotation") {
                this.commonDataService.rightOverlayOption.next("Your Annotations");
              }
              else {
                this.commonDataService.myannotation.next("annotations");
                this.closeOverlay();
              }
            })
          }
        }
        else if (response == "Session expired") {
          let obj = {
            type: 'error',
            displayTime: 3000,
            position: 'bottom',
            message: "You are not authorized , please log in"
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
          this.router.navigate(['Login'])
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: (operation == "add") ? constObj.annotationAddedFailMessage : constObj.annotationEditedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }

  annotationDescriptionError: string = "";
  getAnnotationLabel() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.addAnnotationLabel = labels.filter(x => x.key == "addAnnotation_header").map(y => y.value);
        this.annotatingLabel = labels.filter(x => x.key == "addAnnotation_subtext").map(y => y.value);
        this.annotationTitleOptionalLabel = labels.filter(x => x.key == "addAnnotation_title").map(y => y.value);
        this.yourAnnotationLabel = labels.filter(x => x.key == "addAnnotation_body").map(y => y.value);
        this.cancelButtonLabel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.addButtonLabel = labels.filter(x => x.key == "global_add").map(y => y.value);
        this.editButtonLabel = labels.filter(x => x.key == "global_update").map(y => y.value);
        this.editAnnotationLabel = labels.filter(x => x.key == "editAnnotation_update").map(y => y.value);
        this.annotationDescriptionError = labels.filter(x => x.key == "global_annotation_error_message").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }

}
